import { render, staticRenderFns } from "./set_power2.vue?vue&type=template&id=b3d4be6e&scoped=true"
import script from "./set_power2.vue?vue&type=script&lang=js"
export * from "./set_power2.vue?vue&type=script&lang=js"
import style0 from "./set_power2.vue?vue&type=style&index=0&id=b3d4be6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d4be6e",
  null
  
)

export default component.exports